import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps, pure } from 'recompose';
import uuid from 'uuid';

import ItemPaginator from './ItemPaginator';
import ItemDots from './ItemDots';

import {
  NavPaginator,
  WrapperPaginator,
  ArrowLeftPaginator,
  ArrowRightPaginator
} from './style';

const getPages = (c, m) => {
  const delta = 2;
  const range = [];
  const rangeWithDots = [];
  let l;

  if (c === 1 && m === 1) {
    return rangeWithDots;
  }

  range.push(1);
  for (let i = c - delta; i <= c + delta; i += 1) {
    if (i < m && i > 1) {
      range.push(i);
    }
  }
  range.push(m);

  for (const i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
};

const Paginator = ({
  className,
  onChangePage,
  color,
  pages,
  lastPage,
  currentPage
}) => (
  <NavPaginator className={className}>
    {currentPage !== 1 && (
      <ArrowLeftPaginator
        color={color}
        onClick={() => onChangePage(currentPage - 1)}
      />
    )}
    <WrapperPaginator>
      {pages.map(x =>
        Number.isInteger(x) ? (
          <ItemPaginator
            key={uuid()}
            onClick={() => onChangePage(x)}
            selected={x === currentPage}
          >
            {x}
          </ItemPaginator>
        ) : (
          <ItemDots />
        )
      )}
    </WrapperPaginator>
    {currentPage !== lastPage && (
      <ArrowRightPaginator
        color={color}
        onClick={() => onChangePage(currentPage + 1)}
      />
    )}
  </NavPaginator>
);
Paginator.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onChangePage: PropTypes.func,
  currentPage: PropTypes.number,
  lastPage: PropTypes.number
};

Paginator.defaultProps = {
  color: 'grayDarker'
};

export default compose(
  withProps(({ size, currentPage, total }) => ({
    lastPage: Math.ceil(total / size),
    pages: getPages(currentPage, Math.ceil(total / size))
  })),
  pure
)(Paginator);
